import { Modal as ModalModule } from 'common';
import { StatusModal } from 'common/src/code/modal/StatusModal.component';
import React, { useContext } from 'react';

const { ModalButtonActionType, ModalContext } = ModalModule;

interface ReactivationSuccessfulModalProps {
	data: {
		onConfirm: () => void;
	};
	modalId: string;
}

const ReactivationSuccessfulModal = ({
	data: { onConfirm },
	modalId,
}: ReactivationSuccessfulModalProps) => {
	const { closeModal } = useContext(ModalContext);

	const handleReactivate = () => {
		onConfirm();
		(closeModal as any)(modalId);
	};

	return (
		<StatusModal
			modalId={modalId}
			header="Account Reactivated"
			title="No further action is required."
			description="You can continue using your account now."
			iconType="success"
			onClose={handleReactivate}
			dataqa="reactivation-successful-modal"
			primaryButton={{
				type: ModalButtonActionType.Ok,
				text: 'Done',
				onClick: handleReactivate,
			}}
		/>
	);
};

export default ReactivationSuccessfulModal;
